import React, { useState, useEffect } from 'react';
import PortfolioDemo from './PortfolioDemo';
import ScreenerDemo from './ScreenerDemo';
import MarketTrendsDemo from './MarketTrendsDemo';
import './AnimatedDemo.css';

const DEMOS = {
  portfolio: { component: PortfolioDemo, title: 'How to Analyze a Portfolio' },
  screener: { component: ScreenerDemo, title: 'How to Screen Stocks' },
  trends: { component: MarketTrendsDemo, title: 'Market Trends Overview' },
};

export default function DemoButton({ type = 'portfolio', showPopup = false }) {
  const [showModal, setShowModal] = useState(false);
  const [showPrompt, setShowPrompt] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  const storageKey = `alphagrade_demo_dismissed_${type}`;
  const demo = DEMOS[type];

  useEffect(() => {
    if (!showPopup) return;
    const wasDismissed = localStorage.getItem(storageKey);
    if (wasDismissed) {
      setDismissed(true);
      return;
    }
    // Show prompt after a short delay
    const timer = setTimeout(() => setShowPrompt(true), 800);
    return () => clearTimeout(timer);
  }, [showPopup, storageKey]);

  if (!demo) return null;
  const DemoComponent = demo.component;

  const handleYes = () => {
    setShowPrompt(false);
    setShowModal(true);
  };

  const handleNo = () => {
    setShowPrompt(false);
  };

  const handleNeverShow = () => {
    setShowPrompt(false);
    setDismissed(true);
    localStorage.setItem(storageKey, 'true');
  };

  return (
    <>
      {/* Popup prompt on first visit */}
      {showPrompt && !dismissed && (
        <div className="demo-prompt-overlay">
          <div className="demo-prompt">
            <span className="demo-prompt-icon">🎬</span>
            <h4 className="demo-prompt-title">Want to see a quick demo?</h4>
            <p className="demo-prompt-text">Watch a 15-second walkthrough of how to use this page.</p>
            <div className="demo-prompt-buttons">
              <button className="demo-prompt-yes" onClick={handleYes}>Yes, show me</button>
              <button className="demo-prompt-no" onClick={handleNo}>Not now</button>
              <button className="demo-prompt-never" onClick={handleNeverShow}>Don't show again</button>
            </div>
          </div>
        </div>
      )}

      {/* Demo modal */}
      {showModal && (
        <div className="demo-modal-overlay" onClick={() => setShowModal(false)}>
          <div className="demo-modal" onClick={e => e.stopPropagation()}>
            <button className="demo-modal-close" onClick={() => setShowModal(false)}>&times;</button>
            <div style={{ padding: '0.5rem 0.5rem 0', fontSize: '0.85rem', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '0.5rem', textAlign: 'center' }}>
              {demo.title}
            </div>
            <DemoComponent autoPlay={true} />
          </div>
        </div>
      )}
    </>
  );
}
